import { useEffect, useState } from "react";

import doBulkReview from "../graphql/BulkReviewMutation";

import useQueryVariables from "pstat-anywhere/components/pages/reports/hooks/useQueryVariables";
import { getRootUrl } from "pstat-anywhere/utils/urls";
import useTaskResult from "pstat-anywhere/utils/useTaskResult";
import {
  createErrorMessage,
  createSuccessMessage
} from "pstat-design-system/message/manageMessages";


export default function useDocumentsToReveiwReport({
  router,
  route,
  viewer,
  location,
  labels,
  t
}) {
  const [taskId, setTaskId] = useState(null);
  const { error, loading, result } = useTaskResult(taskId);

  useEffect(() => {
    if (result) {
      createSuccessMessage(
        t("documentReports.expiring.successfulBulkReview", {
          documentLabelPlural: labels.documentLabelPlural.toLowerCase()
        })
      );
      router.push(getRootUrl());
    }
  }, [result, labels.documentLabelPlural, router, t]);
  useEffect(() => {
    if (error) {
      createErrorMessage(
        t("documentReports.expiring.errorBulkReview", {
          documentLabelPlural: labels.documentLabelPlural.toLowerCase()
        })
      );
    }
  }, [error, labels.documentLabelPlural, t]);

  let justMine = true;
  if (route?.data?.routeName === "expiring_all") {
    if (!viewer.userAuth.isSiteAdmin) {
      router.push(`${getRootUrl()}/policy_reports/expiring/mine`);
    }
    justMine = false;
  }

  const { variables } = useQueryVariables({ location });

  function handleBulkReview({ selectedPolicies, comment }) {
    doBulkReview({
      documentPks: selectedPolicies,
      comment,
      callback: successBulkReviewCallback
    });
  }

  function successBulkReviewCallback(response, errors) {
    setTaskId(response.bulkReview.taskId);
  }

  return {
    variables: {
      ...variables,
      justMine
    },
    isSiteAdmin: viewer.userAuth.isSiteAdmin,
    handleBulkReview,
    loading
  };
}
